import React, { useState, useEffect, useMemo } from "react"
import {
  validateFaxNumberOnlyDigit,
  formatFaxNumber,
  prepareFinalFaxNumber,
  isEmpty,
  getOriginatingFaxNumberForHeader,
} from "./../utils/common"
import { post } from "./../utils/apiClient"
import toast from "react-hot-toast"
import { FaxNumberToolTip } from "./common/faxNumberToolTip"
import { FAX_ACTION } from "./../utils/constants"
//import CreatableSelect from "react-select/creatable"

const SendFaxFormModal = ({
  onClose,
  onSave,
  // actionLoading,
  selectedQueue,
  selectedFax,
  destinationfaxNumbers = [],
  destinationFaxNumberLoading,
  tab,
  //document,
}) => {
  const [toName, setToName] = useState("")
  const [toCompany, setToCompany] = useState("")
  const [faxNumber, setFaxNumber] = useState(null)
  const [comment1, setComment1] = useState("")
  const [comment2, setComment2] = useState("")
  const [includeCoverPage, setIncludeCoverPage] = useState(false)
  const [fromName, setFromName] = useState("")
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [actionLoading, setActionLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!faxNumber) {
      setErrorMessage("Fax number is required.")
      return
    } else {
      const errorMsg = validateFaxNumberOnlyDigit(faxNumber?.trim())

      if (errorMsg) {
        setErrorMessage(errorMsg)
        return
      }
    }

    // if (includeCoverPage && (!fromName || !subject || !message)) {
    //   setErrorMessage("All cover page fields must be filled if included.")
    //   return
    // }

    const data = {
      destinations: [
        {
          to_name: toName,
          to_company: toCompany,
          fax_number: prepareFinalFaxNumber(faxNumber),
        },
      ],
      include_cover_page: includeCoverPage,
      coverPageOptions: includeCoverPage
        ? {
            from_name: includeCoverPage ? fromName : null,
            subject: includeCoverPage ? subject : null,
            message: includeCoverPage ? message : null,
          }
        : {},
      userId: selectedQueue?.userId || selectedFax.userId,
      faxId: selectedFax?.fax_id || selectedFax?.faxId,
      // appId: selectedFax?.appId,
      // faxNumber: selectedFax?.faxNumber,
      comment1,
      comment2,
    }

    // onSave(formData)

    const originatingFaxNumberForHeader = getOriginatingFaxNumberForHeader(
      selectedFax,
      tab,
    )

    setActionLoading(true)
    try {
      await post("/fax/sendfax", data, {
        appId: selectedQueue?.appId || selectedFax?.appId,
        faxNumber: selectedQueue?.faxNumber || selectedFax?.faxNumber,
        faxAction: FAX_ACTION.forward,
        originatingFaxNumber: originatingFaxNumberForHeader,
        queueName: selectedQueue?.queue || selectedFax?.copiedFromQueue || "",
        faxType: selectedFax?.faxType || tab.toUpperCase(),
      })

      onClose()
      setActionLoading(false)
      toast.success("Fax has been sent successfully", {
        duration: 5000,
      })
    } catch (error) {
      console.error("Failed to send fax", error)

      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  const optionDestinationFaxNumbers = destinationfaxNumbers.map((fax) => ({
    toName: `${fax.firstName} ${fax.lastName}`,
    toCompany: `${fax.company}`,
    value: fax.faxNumber,
    label: `${formatFaxNumber(fax.faxNumber)} | ${fax.firstName} ${
      fax.lastName
    } ${fax?.company ? `| ${fax?.company}` : ""}`,
  }))

  return (
    <div className="popup-overlay">
      <div className="popup">
        {actionLoading ? (
          <div className="loading" style={{ padding: "20px" }}>
            In progress ...
          </div>
        ) : (
          <>
            <div className="checkbox-popup-header">
              <h3 className="popup-title">
                Forward From Fax
                {selectedQueue?.faxNumberForForward &&
                  ` [${formatFaxNumber(selectedQueue?.faxNumberForForward)}]`}
              </h3>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
            <form
              className="popup-group form-container"
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label htmlFor="email">
                  Fax Number: <span className="mandatory">*</span>
                  <FaxNumberToolTip />
                </label>
                {/* <input
                  type="text"
                  id="faxNumber"
                  value={faxNumber}
                  onChange={(e) => setFaxNumber(e.target.value)}
                /> */}

                {destinationFaxNumberLoading ? (
                  <div style={{ textAlign: "left", padding: "10px" }}>
                    Loading...
                  </div>
                ) : (
                  // <CreatableSelect
                  //   id="faxNumber"
                  //   className="basic-single"
                  //   classNamePrefix="select"
                  //   placeholder="Enter a fax number"
                  //   value={faxNumber} // <-- controlled value
                  //   onChange={(newValue) => {
                  //     setFaxNumber(newValue)
                  //   }}
                  //   options={optionDestinationFaxNumbers}
                  //   styles={{
                  //     control: (base) => ({
                  //       ...base,
                  //       borderRadius: 0,
                  //       textAlign: "left",
                  //     }),
                  //     option: (provided) => ({
                  //       ...provided,
                  //       textAlign: "left",
                  //     }),
                  //     // menu: (provided) => ({
                  //     //   ...provided,
                  //     //   minWidth: "400px", // 👈 minimum width
                  //     //   width: "auto", // 👈 auto until it hits 700px
                  //     // }),
                  //   }}
                  //   formatCreateLabel={(inputValue) =>
                  //     `Custom fax number: "${inputValue}"`
                  //   }
                  //   isSearchable
                  //   onCreateOption={(inputValue) => {
                  //     const newOption = {
                  //       value: inputValue,
                  //       label: inputValue,
                  //     }
                  //     setFaxNumber(newOption) // immediately select it
                  //   }}
                  // />

                  <FaxSearchInput
                    faxNumber={faxNumber}
                    setFaxNumber={setFaxNumber}
                    setToName={setToName}
                    setToCompany={setToCompany}
                    optionDestinationFaxNumbers={optionDestinationFaxNumbers}
                  />
                )}
              </div>

              <div className="form-group">
                <label htmlFor="toName">To Name:</label>
                <input
                  type="text"
                  id="toName"
                  value={toName}
                  onChange={(e) => setToName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="toCompany">To Company:</label>
                <input
                  type="text"
                  id="toCompany"
                  value={toCompany}
                  onChange={(e) => setToCompany(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="comment1">Comment1:</label>
                <input
                  type="text"
                  id="comment1"
                  value={comment1}
                  onChange={(e) => setComment1(e.target.value)}
                  maxLength={45}
                />
              </div>

              <div className="form-group">
                <label htmlFor="comment2">Comment2:</label>
                <input
                  type="text"
                  id="comment2"
                  value={comment2}
                  onChange={(e) => setComment2(e.target.value)}
                  maxLength={45}
                />
              </div>

              <div
                className="form-group checkbox-group"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <div>
                  <input
                    type="checkbox"
                    id="includeCoverPage"
                    checked={includeCoverPage}
                    onChange={(e) => setIncludeCoverPage(e.target.checked)}
                    style={{ marginRight: "5px", width: "20px" }}
                  />
                </div>
                <div>
                  <label
                    htmlFor="includeCoverPage"
                    style={{
                      whiteSpace: "nowrap",
                      marginBottom: "0px",
                      cursor: "pointer",
                    }}
                  >
                    Include Cover Page
                  </label>
                </div>
              </div>

              {includeCoverPage && (
                <>
                  <div className="form-group">
                    <label htmlFor="fromName">From Name:</label>
                    <input
                      type="text"
                      id="fromName"
                      value={fromName}
                      onChange={(e) => setFromName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject:</label>
                    <input
                      type="text"
                      id="subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message:</label>
                    <textarea
                      id="message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      style={{
                        width: "100%",
                        minHeight: "80px",
                        resize: "vertical",
                      }}
                    ></textarea>
                  </div>
                </>
              )}

              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              <div className="popup-buttons">
                <button
                  type="button"
                  className="popup-button cancel"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="popup-button save">
                  Send
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

export default SendFaxFormModal

function FaxSearchInput({
  faxNumber,
  setFaxNumber,
  setToName,
  setToCompany,
  optionDestinationFaxNumbers,
}) {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState("")
  const [hoverIndex, setHoverIndex] = useState(null)

  // keep local query in sync with external faxNumber
  useEffect(() => {
    const v = typeof faxNumber === "string" ? faxNumber : faxNumber?.value || ""
    setQuery(v || "")
  }, [faxNumber])

  const filteredOptions = useMemo(() => {
    if (!query) return optionDestinationFaxNumbers || []
    const q = query.toLowerCase().trim().replace(/-/g, "")
    return (optionDestinationFaxNumbers || []).filter((opt) =>
      String(
        opt.label.trim().replace(/-/g, "") ||
          opt.value.trim().replace(/-/g, "") ||
          "",
      )
        .toLowerCase()
        .includes(q),
    )
  }, [query, optionDestinationFaxNumbers])

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        id="faxNumber"
        name="faxNumber"
        type="text"
        placeholder="Enter a fax number"
        value={query}
        onChange={(e) => {
          const v = e.target.value
          setQuery(v)

          // keep same shape as react-select: { value, label }
          setFaxNumber(v || null)

          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => {
          // allow click to register before closing
          setTimeout(() => setOpen(false), 150)
        }}
        autoComplete="off" // disable browser suggestions
        autoCorrect="off"
        spellCheck={false}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: 0,
        }}
      />

      {open && filteredOptions.length > 0 && (
        <ul class="fax-search-input-ul">
          {filteredOptions.map((opt, idx) => (
            <li
              key={opt.value}
              onMouseDown={(e) => {
                e.preventDefault() // prevent blur before click
                setQuery(formatFaxNumber(opt.value))

                setFaxNumber(formatFaxNumber(opt.value))
                // setToName(opt.toName)
                // setToCompany(opt.toCompany)
                setToName(isEmpty(opt.toName, true) ? "" : opt.toName)
                setToCompany(isEmpty(opt.toCompany, true) ? "" : opt.toCompany)

                setOpen(false)
              }}
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
              style={{
                padding: "7px 10px",
                marginTop: idx === 0 ? "5px" : "0px",
                cursor: "pointer",
                backgroundColor:
                  hoverIndex === idx ? "#bedaf8ff" : "transparent", // 👈 hover effect
              }}
            >
              {opt.label || opt.value}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
